import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

import Header, { AuthKey } from "../components/header";
import Footer from "../components/footer";
import { Box, Typography } from "@mui/material";
import { clearCart, getCart } from "../components/cartLogic";
import { getOrderString, clearOrder, updateOrder, getPaymentIntentId } from "../components/orderLogic";
import { productList } from "../components/productList";

export default function Complete() {
  const paymentIntentId = new URLSearchParams(useLocation().search)?.get('payment_intent') || getPaymentIntentId();
  const [cart, setCart] = React.useState(getCart());
  const [orderSaved, setOrderSaved] = React.useState(false);
  const [orderNumber, setOrderNumber] = React.useState("");
  
  useEffect(() => {
    async function saveOrder() {
      setOrderSaved(true);

      // Verify the order was paid for
      var status = "";
      await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/paymentstatus?marker=" + AuthKey, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: '{ "id": "' + paymentIntentId + '" }',
      })
      .then((res) => res.json())
      .then((data) => {
        status = data.status;
      });

      if (status !== "succeeded") {
         alert("Your order has not been paid for. Please return to the previous checkout page.");
         return;
      }

      // Mark the order as paid
      updateOrder({ "status": "paid" });
      const orderString = getOrderString();
      const order = JSON.parse(orderString);
      // console.log("Order to save: " + orderString);

      setCart(clearCart());

      // Call the lambda to save the order
      await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/saveOrder?marker=" + AuthKey, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: orderString,
      })
      .then((res) => res.json())
      .then((data) => {
         sendOrderEmail(data, order);
      });
    }

    if (!orderSaved && getCart().length > 0) {
      saveOrder();
    }
  }, [orderSaved, paymentIntentId]);

  async function sendOrderEmail(data, order) {
    setOrderNumber(data.orderId);
  
    // Format the order items for the order confirmation email
    let orderItems = 
`<table width='100%'>
  <tr>
      <td><strong>Qty</strong></td>
      <td><strong>Item</strong></td>
      <td><strong>Price</strong></td>
  </tr>
  ${order?.items?.map((item) => {
      return (
      `<tr>
          <td>${item.quantity}</td>
          <td>${productList.filter(p => p.ProductID === item.productId)[0]?.Title}</td>
          <td>${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.unitPrice / 100)}</td>
      </tr>`)}).join('')
  }
  <tr><td>&nbsp;</td></tr>
  <tr>
      <td></td>
      <td><strong>Tax</strong></td>
      <td>${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order?.tax / 100)}</td>    </tr>
  <tr>
      <td></td>
      <td><strong>Shipping & handling</strong></td>
      <td>${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order?.sandh / 100)}</td>
  </tr>
  <tr>
      <td></td>
      <td><strong>Total</strong></td>
      <td>${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order?.total / 100)}</td>
  </tr>
</table>
<br />
<br />`;
    // Remove newlines from the order items string
    orderItems = orderItems.replace(/\n/g, "");
    
    // Send an email with the order confirmation
    const body = {
      "from": "support@veritypublishing.com",   // This is actually ignored and always set to support@veritypublishing.com
      "to": order?.customer.email,
      "subject": "Thank you for your order",
//        "text": "Thank you for your order.\nYour order number is " + orderNumber + ".\nWe will send you another email when your order ships.",
      "html": "<h2>Thank you for your order</h2><h3>Your order number is " + data.orderId + "</h3>" + orderItems + "We will send you another email when your order ships."
    };
    try {
      await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/email?marker=" + AuthKey, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
    }
    catch (err) {
      alert("Your order has been saved, but an error occurred while sending the order confirmation email: " + err);
    }

    // Clear the order so the shopping cart is empty
    clearOrder();
  }
  
  return (<HelmetProvider>
    <Helmet title="Order Complete"/>
    <Header cart={cart} />
    <Box className="mainBox">
      <Box className="subMainBox">
        <h1>Order Complete</h1>
        <Box sx={{ borderRadius: "6px", backgroundColor: "white", padding: "20px" }}>
          <Typography>Thank you for your order.</Typography>
          <Typography>Your order number is <span style={{ fontSize: "1.2em", fontWeight: "bold"}}>{orderNumber}</span>.</Typography>
          <Typography>We have sent you an order confirmation email.</Typography>
          <Typography>We will send you another email when your order ships.</Typography>
        </Box>
      </Box>
    </Box>
    <Footer />
  </HelmetProvider>);
}